import { render, staticRenderFns } from "./midContent.vue?vue&type=template&id=32ffe6a6"
import script from "./midContent.vue?vue&type=script&lang=js"
export * from "./midContent.vue?vue&type=script&lang=js"
import style0 from "./midContent.vue?vue&type=style&index=0&id=32ffe6a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports